/**
 * Formats numbers with smart rounding and shortening
 * - Under 1k: show entire value
 * - 1k to 10k: round to thousands with 1 decimal place (e.g., 5.2k)
 * - 10k to 999,999: round to thousands (e.g., 25k)
 * - 1m to 10m: round to millions with 1 decimal place (e.g., 2.5m)
 * - Over 10m: round to millions (e.g., 25m)
 */
export function formatNumber(value: number): string {
	if (value < 1000) {
		// Under 1k: show entire value
		return value.toLocaleString('en-US', { maximumFractionDigits: 0 })
	} else if (value < 10000) {
		// 1k to 10k: round to thousands with 1 decimal place
		const thousands = value / 1000
		return `${thousands.toFixed(1)}k`
	} else if (value < 1000000) {
		// 10k to 999,999: round to thousands
		const thousands = Math.round(value / 1000)
		return `${thousands}k`
	} else if (value < 10000000) {
		// 1m to 10m: round to millions with 1 decimal place
		const millions = value / 1000000
		return `${millions.toFixed(1)}m`
	} else {
		// Over 10m: round to millions
		const millions = Math.round(value / 1000000)
		return `${millions}m`
	}
}